<div *ngIf="addCheck==true && isAccessible">
    <img src="assets/images/Add_Icon.svg" title="Add Resolution Orders" alt="add" style="height:28px; cursor:pointer;" 
    (click)="this.addResolutionOrders()"/>
  </div>